// extracted by mini-css-extract-plugin
module.exports = {"image":"Picture-module__image___3ioyM","active":"Picture-module__active___11Rjs","caption":"Picture-module__caption___3y7qt","full-bleed":"Picture-module__full-bleed___UDo2B"};